module.exports = __webpack_public_path__ + "img/logo-dara.63f242ab.png";